module.exports = __webpack_public_path__ + "static/img/4-3-aftersale-query-result.5bbbca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/4-3-aftersale-query-result.png
// module id = 1342
// module chunks = 0